import { render, staticRenderFns } from "./randki-bez-rejestracji.vue?vue&type=template&id=404e6118&"
import script from "./randki-bez-rejestracji.vue?vue&type=script&lang=js&"
export * from "./randki-bez-rejestracji.vue?vue&type=script&lang=js&"
import style0 from "./randki-bez-rejestracji.vue?vue&type=style&index=0&id=404e6118&prod&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {MarketingDatingDemo: require('/var/www/jaty-frontend/components/marketing/DatingDemo.vue').default})
